export default (ratio: string, width: number, defaultHeight = 100) => {
  if (!ratio.includes(':')) return defaultHeight;
  
  const [widthRatio, heightRatio] = ratio.split(':');
  return (width / +widthRatio) * +heightRatio;
};
